import { YouTubeDebugPage } from "@/components/debugging/youtube-debug-pages";

export default function DebugEmbeddedYouTubeStep01Page() {
  return <YouTubeDebugPage stepNumber="01" />;
}
